import React from 'react';
import { Link } from 'react-router-dom';

const PageBanner = ({ title, subtitle, breadcrumbs = [], backgroundImage, fallback, loading = false }) => {
  // Ignored static fallbacks as per user request: "direct live api backend bale hi load hone chahiye"
  const src = backgroundImage; 
  
  return (
    <div className="page-hero bg-primary">
      {!loading && src ? <img src={src} alt={title || 'Banner'} className="page-hero-img" /> : null}
      <div className="page-hero-content">
        <div className="container">
          <div className="page-hero-inner">
            <div className="w-full text-center">
              {title && (
                <h1 className="h-display text-white mb-2">
                  {title}
                </h1>
              )}
              {subtitle && (
                <p className="text-white text-center text-lg md:text-xl font-medium opacity-90 max-w-3xl mx-auto">
                  {subtitle}
                </p>
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PageBanner;
